import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Footer from "../../components/comunes/Footer";
import TablaLeadsMeta from "../../components/administracion/TablaLeadsMeta";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth";

const MetaLeads = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const verificar = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const r = await fetch(process.env.REACT_APP_API_TOKEN, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (!r.ok) navegacion("/");
            } catch { navegacion("/"); }
            finally { setCargando(false); }
        };
        verificar();
    }, [navegacion]);

    if (cargando) return null;

    return (
        <div className={darkMode ? "bg-dark text-white min-vh-100" : "bg-light min-vh-100"}>
            <div className="container-fluid py-4 px-4">
                <h5 className="mb-1 fw-bold">Leads de Facebook & Instagram</h5>
                <p className="text-muted mb-4" style={{ fontSize: 13 }}>
                    Todos los leads recibidos desde formularios de Meta Lead Ads.
                </p>
                <TablaLeadsMeta />
            </div>
            <Footer />
        </div>
    );
};

export default MetaLeads;
